import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  section: {
    width: '100%',
    padding: theme.spacing(1, 0, 2),
  },
  paperActions: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  smallButton: {
    alignSelf: 'center',
    fontSize: '0.75rem',
    padding: '5px 14px',
    minHeight: 0,
    lineHeight: 1.6,
    boxShadow: 'none',
  },
  help: {
    color: 'rgba(0, 0, 0, 0.54)',
    fontSize: '0.8rem',
    marginTop: theme.spacing(0.5),
  },
}));
